import React from 'react';
import { Button } from "@my-swipestox/components";
import styled from 'styled-components';
import { useTranslation } from "react-i18next";
import { Info, XCircle, CheckCircle } from "react-feather";

import HelperFunctions from "../../helpers/helper";
import constants from "../../constants";

const TransactionCompletedWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: ${(props) => props.theme.color.backgroundSecondary};
  display: flex;
  z-index: 1001;
`;

const TransactionCompletedContent = styled.div`
  display: block;
  flex-direction: column;
  text-align: center;
  margin: auto;
`;

const TransactionCompletedMessage = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 16px;
`;

const InfoIcon = styled(Info)`
  color: ${(props) => props.theme.color.primary};
  height: 85px;
  width: 85px;
`;

const CheckCircleIcon = styled(CheckCircle)`
  color: ${(props) => props.theme.color.primary};
  height: 85px;
  width: 85px;
`;

const ErrorIcon = styled(XCircle)`
  color: ${(props) => props.theme.color.negative};
  height: 85px;
  width: 85px;
`;

const PraxisTransactionCompleted = (props, context) => {
  const { t } = useTranslation();

  const status = HelperFunctions.getParameterByName('status');
  const currency = HelperFunctions.getParameterByName('currency');
  const amount = HelperFunctions.getParameterByName('amount') / 100; // Praxis amount is in cents
  const type = HelperFunctions.getParameterByName('type');

  const successfulDeposit = status === constants.PRAXIS.STATUS.APPROVED;
  const pendingDeposit = constants.PRAXIS.PENDING_STATUSES.includes(status);

  const gotoDefaultRoute = () => {
    window.top.location = '/';
  };

  return (
    <TransactionCompletedWrapper>
      {successfulDeposit ? (
        <TransactionCompletedContent>
          <CheckCircleIcon />
          <TransactionCompletedMessage>
            <p>
              {t(type === 'withdraw' ? 'FUND_ACCOUNT.WITHDRAWAL_COMPLETED_MESSAGE' : 'FUND_ACCOUNT.DEPOSIT_COMPLETED_MESSAGE', {
                currency: currency,
                amount: amount,
              })}
            </p>
          </TransactionCompletedMessage>
          <Button onClick={gotoDefaultRoute}>
            {t('FUND_ACCOUNT.DEPOSIT_COMPLETED_GO_TO_HOME')}
          </Button>
          </TransactionCompletedContent>
      ) : (
        <TransactionCompletedContent>
          {pendingDeposit ? <InfoIcon /> : <ErrorIcon />}
          <TransactionCompletedMessage>
            <p> {t(pendingDeposit ? (type === 'withdraw' ? 'WITHDRAW.REQUEST_RECEIVED' : 'FUND_ACCOUNT.TRANSACTION_PENDING') : 'FUND_ACCOUNT.TRANSACTION_COMPLETED_ERROR')}</p>
          </TransactionCompletedMessage>
          <Button onClick={gotoDefaultRoute}>
            {t('FUND_ACCOUNT.DEPOSIT_COMPLETED_GO_TO_HOME')}
          </Button>
        </TransactionCompletedContent>
      )}
    </TransactionCompletedWrapper>
  );
};

export default PraxisTransactionCompleted;
